/**
 * Copyright 2024 https://github.com/material-icons/material-icons
 * SPDX-License-Identifier: Apache-2.0
 */
import { FC } from 'react'

export const TimesIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_546_5128)">
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill="#565B61"
      />
    </g>
    <defs>
      <clipPath id="clip0_546_5128">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
